import React from 'react';
import { Container } from '@mui/material';
import Layout from '../../components/Layout';
import DriverScheduleSection from '../../components/manager/DriverScheduleSection';
import { useIsCompact } from '../../hooks/useIsMobile';

const DriverSchedule = () => {
  const isCompact = useIsCompact();

  return (
    <Layout>
      <Container maxWidth="lg">
        <DriverScheduleSection selfView isMobile={isCompact} />
      </Container>
    </Layout>
  );
};

export default DriverSchedule;
